import React, { Fragment, useEffect, useRef } from 'react';
import {
    string, node, shape, arrayOf,
} from 'prop-types';
import { withRouter } from 'react-router';
import withApplicationConfig from 'containers/withApplicationConfig';

const loadGtm = (_id) => {
    const script = document.createElement('script');
    script.async = true;
    script.type = 'module';
    script.src = '/_tags/tags.js';
    document.head.append(script);
    /* eslint-disable */
};

const TrackingProvider = ({
  gtmId, children, location: { pathname }, gtmBlacklist,
}) => {
  const isGtmLoaded = useRef(false);

  useEffect(() => {
    if (!gtmId) return;
    // Only run on client side
    if (typeof window === 'undefined') return;
    if (isGtmLoaded.current) return;

    const isPathBlacklisted = gtmBlacklist.reduce(
      (a, blacklistPath) => a || (blacklistPath?.length > 0 && pathname.includes(blacklistPath)),
      false,
    );

    if (isPathBlacklisted) return;

    loadGtm(gtmId);
    isGtmLoaded.current = true;
  }, [pathname]);

  return (
    <Fragment>
      {children}
    </Fragment>
  );
};

TrackingProvider.propTypes = {
  gtmId: string,
  children: node,
  gtmBlacklist: arrayOf(string).isRequired,
  location: shape({}).isRequired,

};

TrackingProvider.defaultProps = {
  gtmId: null,
  children: null,
};

export default withRouter(withApplicationConfig(TrackingProvider, ['tracking']));
